module.exports = __webpack_public_path__ + "img/coin 20.42a5fce1.png";